/**
 * @param className {string}
 * @param index {number}
 * @param data {string}
 * @returns {*|null}
 * @constructor
 * @deprecated use datasetParser instead main/symfony/src/Bus/FrontBundle/React/src/services/utils/datasetParser.js
 */
export default function datasetExtractor(className: string, index: number, data?: string) {
    return (
        // @ts-ignore
        document.getElementsByClassName(className)[index].dataset[data] || null
    )
}